export default __webpack_public_path__ + "static/media/item_1.81428681.webp";